<template>
  <component
    :is="tag"
    :contenteditable="editable"
    @input="update"
    @paste="onPaste"
    @focusout="onBlur"
    :class="['dynamic-content',{hovering:showHover}, {'empty-text' : empty}]"
    v-toggle-select
    v-on-clickaway="deselect"    
  >
    <slot/>
  </component>
</template>

<script>
import VueClickaway from 'vue-clickaway'
import ToggleSelect from '../toggle-select'

export default {

  name: 'EditableTextField',
  mixins : [ VueClickaway.mixin, ToggleSelect ],  
  props : {
    'editable' : Boolean,
    'content' : [String, Number],
    'tag' : {
      type: String,
      default : 'div'
    },
    'blur' : {
      type: Function,
      required: false
    }
  },
  data() {
    return {
      hovering:false
    }
  },
  computed : {
    showHover() {
      return this.hovering && !this.selected
    },
    empty() {
      return !this.content || !this.content.toString().length
    }
  },
  mounted:function(){
    this.$el.innerText = this.content;
  },
  methods:{
    onBlur( event ) {
      this.$emit('onBlur', event, this.content )
    }, // onBlur
    update:function(event){
      this.$emit('update',event.target.innerText);
    },
    onPaste(e){
      // Prevent the default pasting event and stop bubbling
      e.preventDefault();
      e.stopPropagation();

      // Get the clipboard data
      let paste = (e.clipboardData || window.clipboardData).getData('text');
      
      // Do something with paste like remove non-UTF-8 characters
      paste = paste.replace(/[^\x20-\xFF]/gi, '');

      // Find the cursor location or highlighted area
      const selection = window.getSelection();

      // Cancel the paste operation if the cursor or highlighted area isn't found
      if (!selection.rangeCount) return false;

      this.replaceSelectedText( paste );

    }, // onPaste

    replaceSelectedText(replacementText) {
      var sel, range;
      if (window.getSelection) {
          sel = window.getSelection();
          if (sel.rangeCount) {
              range = sel.getRangeAt(0);

              // Polyfill: check for the insertText support
              if (document.queryCommandSupported('insertText')) {
                  document.execCommand( 'insertText', false, replacementText );
              } else {
                range.deleteContents();
                range.insertNode(document.createTextNode(replacementText));
              }                           
          }
      } else if (document.selection && document.selection.createRange) {
          range = document.selection.createRange();
          range.text = replacementText;
      }
    }, // replaceSelectedText
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EditableTextField.vue